// components/filters/TotalOOFilter.js
import React from "react";
import FilterBase from "../FilterBase";
import Input from "../../ui/Input";
import Space from "../../ui/Space";
import { FILTER } from "../../utils/Struct";
import Button from "../../ui/Button";
import { kbdEvent } from "../../utils/Utils";
import { KBD } from "../../utils/Keybindings";
import { ENUMS } from "../../utils/Enums";

export default function OptionalInputs(props) {

    const { onSave = () => { }, onClose = () => { }, filter = {}, inputParams = {}, edit = false } = props;

    const { value = 0, type = 0 } = filter;

    let text = filter.text;
    let _data = ENUMS.REPORT_FILTERS.find(item => item.value === type) || false;
    if (_data) {
        text = _data.text;
        // data.value_1
    }

        const parts = filter?.value_1 ? filter?.value_1.split("|") : [];


    const fields = [
        { key: "input_1", value: (edit) ? parts[0] : "", help: "Enter a value." },
        { key: "input_2", value: (edit) ? parts[1] : "", help: "Enter a value." },
        { key: "input_3", value: (edit) ? parts[2] : "", help: "Enter a value." },
        { key: "input_4", value: (edit) ? parts[3] : "", help: "Enter a value." },
        { key: "input_5", value: (edit) ? parts[4] : "", help: "Enter a value." },
        { label: "save", key: "save", value: "", help: "Press Enter to save" },
    ];

    const save = (tabs) => {

        let _a = [];
        _a.push(tabs.find(f => f.key === "input_1").value);
        _a.push(tabs.find(f => f.key === "input_2").value);
        _a.push(tabs.find(f => f.key === "input_3").value);
        _a.push(tabs.find(f => f.key === "input_4").value);
        _a.push(tabs.find(f => f.key === "input_5").value);

        const value_1 = _a.filter((item) => item).join("|")
        const _f = {
            ...FILTER,
            type: value,
            value_1: value_1.toString()
        }
        onSave(_f, filter);
    }

    return (
        <FilterBase fields={fields} onClose={() => onClose()} onSave={(tabs) => {
            save(tabs)
        }}>
            {({ editProps, update, tabs, proceed }) => (
                <div>
                    <Space>
                        <span>{text}</span>
                        <Input {...editProps("input_1")} {...inputParams} onFill={(e) => { proceed() }} />
                        <Input {...editProps("input_2")} {...inputParams} onFill={(e) => { proceed() }} />
                        <Input {...editProps("input_3")} {...inputParams} onFill={(e) => { proceed() }} />
                        <Input {...editProps("input_4")} {...inputParams} onFill={(e) => { proceed() }} />
                        <Input {...editProps("input_5")} {...inputParams} onFill={(e) => { proceed() }} />
                        <Button onClick={() => save(tabs)} {...editProps("save")}>Save</Button>
                    </Space>
                </div>
            )}
        </FilterBase>
    );
}
